interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  color?: string;
}

export default function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  color = '#FF1493'
}: EmptyStateProps) {
  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(26, 31, 46, 0.8), rgba(36, 41, 56, 0.8))',
      border: `2px solid ${color}40`,
      borderRadius: '12px',
      padding: '60px 40px',
      textAlign: 'center',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <div style={{
        fontSize: '64px',
        marginBottom: '20px',
        opacity: 0.5
      }}>
        {icon}
      </div>
      <h2 style={{
        fontSize: '24px',
        fontWeight: 700,
        color: color,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        marginBottom: '12px',
        fontFamily: 'Rajdhani, sans-serif'
      }}>
        {title}
      </h2>
      <p style={{
        fontSize: '16px',
        color: '#8A95AA',
        marginBottom: actionLabel ? '24px' : 0,
        lineHeight: 1.6,
        fontFamily: 'Rajdhani, sans-serif'
      }}>
        {description}
      </p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          style={{
            padding: '12px 24px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: 700,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            border: `2px solid ${color}`,
            background: `${color}33`,
            color: color,
            boxShadow: `0 0 20px ${color}4D`,
            fontFamily: 'Rajdhani, sans-serif'
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
